export default __webpack_public_path__ + "static/media/Feautured_1.05c3b39e.png";